import { config } from '@services/config';
import {
  IneligibilityByOfferingListRequestQuery,
  IneligibilityByOfferingRequestParams,
  IneligibilityByOfferingListResponse,
} from '@lio/api-types';
import { offeringIneligibilityQueryKey } from '@services/ineligibility/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

const searchOfferingIneligibilityQueryParams = (params: IneligibilityByOfferingListRequestQuery) => {
  const { productOptionId, effectiveDate, sort, pageLimit, pageOffset } = params;
  const query = new URLSearchParams();
  if (productOptionId) {
    query.append('productOptionId', productOptionId);
  }
  if (effectiveDate) {
    query.append('effectiveDate', effectiveDate);
  }
  if (sort) {
    query.append('sort', sort);
  }
  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }
  return query.toString();
};

export const useSearchOfferingIneligibility = (
  requestParams?: IneligibilityByOfferingRequestParams,
  requestQuery?: IneligibilityByOfferingListRequestQuery,
) => {
  const client = useClient();
  const query = searchOfferingIneligibilityQueryParams({ ...requestQuery, pageLimit: 100 });
  const result = useQuery<IneligibilityByOfferingListResponse, Error>({
    queryKey: offeringIneligibilityQueryKey.searchWithParams({ ...requestQuery, pageLimit: 100 }),
    queryFn: async () => {
      const response = await client
        .get(`offering/${requestParams?.offeringId}/ineligibility?${query}`)
        .json<IneligibilityByOfferingListResponse>();
      return response;
    },
    enabled: requestParams?.offeringId !== undefined,
    ...config,
  });
  return { ...result, offeringIneligibility: result.data };
};
